import React from 'react';
import { profile } from '../data';

function Contact() {
  return (
    <section className="section" id="contact">
      <div className="section-head reveal" style={{ textAlign: 'center' }}>
        <span className="eyebrow">
          <i className="fa-solid fa-paper-plane"></i> Contact
        </span>
        <h2 className="section-title">
          Let's <span className="gradient-text">work together</span>
        </h2>
        <p className="section-sub" style={{ margin: '0 auto' }}>
          Have a project in mind or just want to say hi? My inbox is always open.
        </p>
      </div>

      <div style={{ textAlign: 'center' }} className="reveal">
        <a href={`mailto:${profile.email}`} className="btn btn-primary">
          <i className="fa-solid fa-envelope"></i> Say hello
        </a>
      </div>

      <div className="contact-methods">
        <a className="contact-method card reveal" href={`mailto:${profile.email}`}>
          <i className="fa-solid fa-envelope"></i>
          <div>
            <div className="cm-label">Email</div>
            <div className="cm-value">{profile.email}</div>
          </div>
        </a>
        <a className="contact-method card reveal" href={`tel:${profile.phone.replace(/\s/g, '')}`}>
          <i className="fa-solid fa-phone"></i>
          <div>
            <div className="cm-label">Phone</div>
            <div className="cm-value">{profile.phone}</div>
          </div>
        </a>
        <a
          className="contact-method card reveal"
          href={profile.socials.linkedin}
          target="_blank"
          rel="noreferrer"
        >
          <i className="fa-brands fa-linkedin-in"></i>
          <div>
            <div className="cm-label">LinkedIn</div>
            <div className="cm-value">Purushothama G</div>
          </div>
        </a>
        <a
          className="contact-method card reveal"
          href={profile.socials.github}
          target="_blank"
          rel="noreferrer"
        >
          <i className="fa-brands fa-github"></i>
          <div>
            <div className="cm-label">GitHub</div>
            <div className="cm-value">PurushothamaG96</div>
          </div>
        </a>
      </div>
    </section>
  );
}

export default Contact;
